import { Button } from "@yleisradio/yds-components-react";
import { darkTheme, spacing, typography } from "@yleisradio/yds-core";
import styled from "styled-components";

export const NonPlayableVideoText = styled.div`
  color: ${darkTheme.TEXT_DEFAULT};
  font-weight: ${typography.DEFAULT_XL_BOLD_FONT_WEIGHT};
  font-size: ${typography.DEFAULT_XL_BOLD_FONT_SIZE};
  line-height: ${typography.DEFAULT_XL_BOLD_LINE_HEIGHT};
  padding: ${spacing.SPACING_24};
  text-align: center;
`;

export const NonPlayableVideoOverlay = styled.div`
  align-items: center;
  background-color: ${darkTheme.BACKGROUND_DIALOG_OVERLAY};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const NonPlayableButton = styled(Button).attrs({
  variant: "secondary"
})`
  border-color: ${darkTheme.BORDER};
  color: ${darkTheme.TEXT_DEFAULT};
  margin-top: ${spacing.SPACING_16};

  &:hover {
    border-color: ${darkTheme.BORDER};
  }
`;

export const WithAnimatedEllipsis = styled.span`
  position: relative;
  overflow: hidden;

  @keyframes ellipsis {
    100% {
      width: 1.25em;
    }
  }

  :after {
    animation: ellipsis steps(4, end) 900ms infinite alternate;
    content: "\\2026"; /* ascii code for the ellipsis character */
    display: inline-block;
    margin-right: 1.25em;
    overflow: hidden;
    position: absolute;
    vertical-align: bottom;
    width: 0;
  }
`;

export const TextNoWrap = styled.span`
  white-space: nowrap;
`;
